import { Link } from "react-router-dom";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";

const FAQS = [
  {
    q: "How long does delivery take?",
    a: "New Zealand and Australia: 10–21 business days. Rest of the world: 14–28 business days. Every order gets a confirmation email, and we email your tracking number the moment it ships.",
  },
  {
    q: "How much is shipping?",
    a: "Flat $9.99 to NZ & Australia, free on orders over $75. Rest of the world is a flat $24.99, free over $250.",
  },
  {
    q: "How does tracking work?",
    a: "As soon as your order ships you'll get an email with a tracking number and a live tracking link. You can also check progress anytime on our Track Order page using your order ID.",
  },
  {
    q: "Will my items arrive together?",
    a: "If you order more than one item, they may arrive in separate parcels — each piece ships as soon as it's ready, at no extra cost to you.",
  },
  {
    q: "What about sizing?",
    a: "Our shirts run true to size with a relaxed athletic fit. Check the size guide on each product page — if you're between sizes, we recommend sizing up.",
  },
  {
    q: "Is GST or tax included?",
    a: "Yes. NZ GST (15%) and AU GST (10%) are calculated and shown at checkout, so the price you see at checkout is the full price — no surprises on delivery.",
  },
  {
    q: "What's your returns policy?",
    a: "If something's wrong with your order — damaged, faulty or not as described — contact us within 30 days of delivery and we'll replace or refund it. Wrong size? We'll exchange it (you cover the return postage). Full details on our Shipping & Returns page.",
  },
  {
    q: "How do I add a printed name to a shirt?",
    a: "On products that support it, you'll see an 'Add a name' box on the product page. Type the name (up to 20 characters) and you'll see a live preview on the shirt photo before you order.",
  },
  {
    q: "How can I pay?",
    a: "Card payments are processed securely by Stripe, or you can use PayPal. We charge in NZD for New Zealand and AUD for Australia.",
  },
  {
    q: "How do I contact you?",
    a: "Email support@gobigforever.com, use the chat bubble in the corner, or send a message through our Contact page. We reply within 1 business day, 7 days a week.",
  },
];

export default function FAQ() {
  return (
    <div className="max-w-3xl mx-auto px-5 sm:px-8 py-16" data-testid="faq-page">
      <p className="overline mb-2">Help centre</p>
      <h1 className="font-display text-4xl sm:text-5xl font-black tracking-tight mb-8">Frequently asked questions</h1>
      <Accordion type="single" collapsible className="w-full">
        {FAQS.map((f, i) => (
          <AccordionItem key={f.q} value={`item-${i}`} data-testid={`faq-item-${i}`}>
            <AccordionTrigger className="text-left font-semibold">{f.q}</AccordionTrigger>
            <AccordionContent className="text-muted-foreground leading-relaxed">{f.a}</AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>
      <p className="text-sm text-muted-foreground mt-10">
        Still stuck? <Link to="/contact" className="underline font-medium hover:text-brand">Contact us</Link> — we're happy to help.
      </p>
    </div>
  );
}
